import { SynopticLogoCompactIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo-compact.js';
import { floatingWatermarkPanel } from './route.css';

export const GraphWatermark = () => {
  return (
    <div className={floatingWatermarkPanel}>
      <SynopticLogoCompactIcon height={20} />
      synoptic.com/ct
    </div>
  );
};
